<script lang="typescript">
    import type { LensBenefit } from "./types";

    export let benefit: LensBenefit;

    let overlay: HTMLDivElement;

    const handleMouseEnter = () => {
        overlay.classList.remove("opacity-10");
        overlay.classList.add("opacity-0");
    };
    const handleMouseLeave = () => {
        overlay.classList.add("opacity-10");
        overlay.classList.remove("opacity-0");
    };
    let isSVG: boolean = benefit.image.endsWith(".svg");
</script>

<div
    class="img-container w-24 flex flex-col items-center text-center mb-2 cursor-default"
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
>
    <div class="relative">
        <img
            class="w-16 h-16 rounded-full object-cover {isSVG ? 'bg-primary-light' : ''}"
            src={benefit.image}
            alt="lens benefit"
        />
        <div class="hide-on-hover img-overlay opacity-10" bind:this={overlay} />
    </div>
    <h4 class="mt-4">{benefit.title}</h4>
</div>
